import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Pricing from "@/components/Pricing";
import SEO from "@/components/SEO";
import { BreadcrumbSchema } from "@/components/StructuredData";

const PricingPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Pricing Plans - SKECHA"
        description="Choose the perfect SKECHA plan for your family. Start free or upgrade for unlimited coloring page creations. Flexible pricing for every creative need."
        keywords="skecha pricing, coloring page plans, subscription pricing, free coloring pages, premium plans"
        url="https://skecha.com/pricing"
      />
      <BreadcrumbSchema
        items={[
          { name: "Home", url: "https://skecha.com" },
          { name: "Pricing", url: "https://skecha.com/pricing" },
        ]}
      />
      <Header />
      <main>
        <Pricing />
      </main>
      <Footer />
    </div>
  );
};

export default PricingPage;
